import TextAreaInputBase from '../FormUtils/TextareaInput/textarea-input-base'
import { INote } from '../../models/contact_companies'
import { useEffect, useState } from 'react'
import apiService from '../../services/api'
import { Modal } from '../UI/Modal/Modal'

export default function NotesModal(props: {
  noteToEdit?: INote
  show: boolean
  handleClose: () => void
  chainId: number | undefined
  contactCompanyId: number | undefined
}) {
  const api = apiService()
  const [noteContent, setNoteContent] = useState<string>('')
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

  async function onSubmit() {
    setIsSubmitting(true)
    if (props.noteToEdit) {
      await api.editNote(props.noteToEdit.id, noteContent)
    } else {
      await api.createNote(props.chainId, props.contactCompanyId, noteContent)
    }
    setIsSubmitting(false)
    props.handleClose()
  }

  useEffect(() => {
    if (props.noteToEdit) {
      setNoteContent(props.noteToEdit.content)
    } else {
      setNoteContent('')
    }
  }, [props.noteToEdit])

  return (
    <Modal
      open={props.show}
      onOpenChange={(open) => !open && props.handleClose()}
      title={props.noteToEdit ? 'Edit this Note' : 'Add a Note'}
      onAccept={onSubmit}
      acceptButtonText={props.noteToEdit ? 'Edit' : 'Add'}
      loading={isSubmitting}
    >
      <TextAreaInputBase
        value={noteContent}
        onChange={(e) => setNoteContent(e.target.value)}
        style={{
          width: '100%',
        }}
      />
    </Modal>
  )
}
